
import { KngTableLoaderState } from './definitions';

export class KngTableLoaderFactory 
{
	public static build(): KngTableLoaderState 
	{
		return {
			noOfColumns: 0,
			noOfRows: 0
		};
	}
}
